import type { ComponentSchema } from '../../../../../schema-types'
import { CONTENT_PAGES, headingFields, SECTION_STYLE_FIELDS } from './_fields'

/** "Shop by category" tiles: chosen categories or links, or the store's categories when none are listed. */
export const schema: ComponentSchema = {
  type: 'category-bento',
  label: 'Category tiles',
  description: 'Round photo tiles or tint cards linking to categories.',
  supportedPages: CONTENT_PAGES,
  variants: [
    { id: 'v1', label: 'Round tiles' },
    { id: 'v2', label: 'Bento cards' },
  ],
  commonFields: [
    ...headingFields({ eyebrow: 'Browse', title: 'Shop by category' }),
    {
      key: 'tiles',
      label: 'Tiles',
      type: 'array',
      help: 'Empty = the store’s categories.',
      itemSchema: [
        { key: 'categoryId', label: 'Category', type: 'category-select', help: 'Sets the link, name and picture unless filled below.' },
        { key: 'title', label: 'Name', type: 'localized-string' },
        { key: 'tagline', label: 'Tagline', type: 'localized-string' },
        { key: 'image', label: 'Picture', type: 'image' },
        { key: 'link', label: 'Link', type: 'string', placeholder: '/category/…' },
      ],
      default: [],
    },
    { key: 'limit', label: 'Categories shown (automatic tiles)', type: 'number', default: 8 },
    ...SECTION_STYLE_FIELDS,
  ],
}
